<template>
  <div>
    <Frontendlayout>
      <section class="hero_in tours">
        <div class="wrapper">
          <div class="container">
            <h1 class="fadeInUp"><span></span>Offer Categories</h1>
          </div>
        </div>
      </section>
      <!--/hero_in-->

      <div class="container margin_60_35">
        <div class="row">
          <Sidebar />
          <!-- /aside -->

          <div class="col-lg-9">
            <div class="isotope-wrapper">
              <div class="row">
                <div class="box_general padding_bottom">
                  <form
                    autocomplete="off"
                    @submit.prevent="updateOffer()"
                    method="post"
                  >
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>Discount to be offered in</label>
                          <select
                            v-model="categories.offer_in"
                            class="form-control"
                            id="exampleFormControlSelect1"
                          >
                            <option value="value">Value</option>
                            <option value="percent">Percent</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>Enter offer in percent / amount </label>
                          <input
                            class="form-control"
                            type="text"
                            v-model="categories.offer_value"
                            placeholder="Offer Value"
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>Select Location </label>
                          <input
                            class="form-control"
                            type="text"
                            v-model="categories.location"
                            placeholder="Location"
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>Pincode </label>
                          <input
                            class="form-control"
                            type="text"
                            v-model="categories.pincode"
                            placeholder="Pincode"
                            maxlength="6"
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>Valid From</label>
                          <date-picker
                            v-model="categories.valid_from"
                            :config="validFromConfig"
                          ></date-picker>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>Valid Till</label>
                          <date-picker
                            v-model="categories.valid_till"
                            :config="datepickerconfig"
                          ></date-picker>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>Short description (Max 160 word)</label>
                          <textarea
                            class="form-control"
                            v-model="categories.short_description"
                            maxlength="160"
                            @keyup="wordcount"
                          ></textarea>
                          <i>word count:{{ short_descriptionCount }}</i>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group">
                          <label
                            >Long description (Max 500 words allowed)</label
                          >

                          <ckeditor
                            :editor="editor"
                            v-model="categories.description"
                            :config="editorConfig"
                            maxlength="500"
                            @keyup="wordcount2"
                          ></ckeditor>
                          <i>word count:{{ long_descriptionCount }}</i>
                        </div>
                      </div>
                    </div>
                        <div
                        class="modal fade bd-example-modal-lg"
                        tabindex="-1"
                        role="dialog"
                        aria-labelledby="myLargeModalLabel"
                        aria-hidden="true"
                      >
                      
                        <div class="modal-dialog modal-xl">
                          <div class="modal-content">
                            <Areaofinterest v-if="categories" :category_id="category_id" :category="categories.offer_categories" @clicked="onClickChild" />
                          </div>
                        </div>
                      </div>
                    <!-- /row -->

                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <h5>Category</h5>
                          <a
                            @click="openLoginModal()"
                            href="javascript:void(0);"
                            >Edit</a
                          >
                          <div
                            class="form-check category"
                            v-for="cat in categories.offer_categories"
                            :key="cat.id"
                          >
                            <input
                                class="form-check-input"
                                type="checkbox"
                                :value="cat.category_id"
                                v-model="category_id"
                              />
                              <label class="form-check-label" for="" >{{
                                cat.category
                              }}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id="pass-info" class="clearfix"></div>
                    <div class="form-group">
                      <button
                        type="submit"
                        class="btn_1 rounded full-width add_top_30"
                        :disabled="loading"
                      >
                        <span
                          v-show="loading"
                          class="spinner-border spinner-border-sm"
                        ></span>
                        Submit!
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <!-- /row -->
            </div>
            <!-- /isotope-wrapper -->
          </div>
          <!-- /col -->
        </div>
      </div>

      <!-- /container -->
      <!-- /bg_color_1 -->
    </Frontendlayout>
  </div>
</template>

<script>
import API from "../services/index.js";
import Frontendlayout from "../layouts/Frontendlayout.vue";
import Sidebar from "../layouts/Sidebar.vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import moment from "moment";
import Areaofinterest from "../components/Areaofinterest.vue";

export default {
  data() {
    return {
      loading: false,
      token: "Bearer " + localStorage.getItem("token"),
      categories: [],
      offer_in: "",
      category_id: [],
      offer_value: "",
      location: "",
      pincode: "",
      validFromConfig: {
        format: "DD/MM/YYYY hh:mm a",
        useCurrent: false,
        minDate: new Date(),
      },
      valid_till: new Date(),
      valid_from: new Date(),

      datepickerconfig: {
        format: "DD/MM/YYYY hh:mm a",
        useCurrent: false,
        minDate: new Date(),
      },
      msg: null,
      classAlert: null,
      editor: ClassicEditor,
      short_descriptionCount: 0,
      long_descriptionCount: 0,
      editorData: "<p>Content of the editor.</p>",
      editorConfig: {
        // The configuration of the editor.
        maxlength: "500",
      },
    };
  },
  components: {
    Frontendlayout,
    Sidebar,
    Areaofinterest,
  },
  beforeMount() {
    this.checkToken();
    this.getOffercategories();
  },

  methods: {
    openLoginModal() {
      window.$(".bd-example-modal-lg").modal("show");
    },
     onClickChild (value,id) {
   // someValue

           this.categories.offer_categories=value
           this.category_id=id
      },
    checkToken() {
      const token = localStorage.getItem("token");
      // alert(token);
      if (token == null) {
        this.$router.push("/signin");
      }
    },
    wordcount(e) {
      this.short_descriptionCount = e.target.value.length;
      //alert(e.target.value.length);
    },
    wordcount2(e) {
      this.long_descriptionCount = e.target.value.length;
    },
    set_offer_in(event) {
      alert(this.categories.offer_in);
      this.categories.offer_in = " target.value: " + event.target.value;
    },
    getOffercategories() {
      let id = this.$router.currentRoute.params.id;
      API.get("offer/offer_by_offerId/" + id, {
        headers: { Authorization: this.token },
      })
        .then((res) => {

          this.categories = res.data.data;
          res.data.data.offer_categories.forEach(value => {
            this.category_id.push(value.category_id)
          })
          this.categories.valid_from = moment(
            this.categories.valid_from
          ).format("DD/MM/YYYY h:m a");
          //alert(this.categories.valid_from);
          this.categories.valid_till = moment(
            this.categories.valid_till
          ).format("DD/MM/YYYY h:m a");
          this.short_descriptionCount = res.data.data.short_description.length;
          this.long_descriptionCount = res.data.data.long_description.length;

          //alert("hii");
          //alert(this.categories.valid_from);
          //alert(res.data.data.long_description.length);
          //console.log(this.categories);
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    frontendDateFormat(date) {
      if (date) {
        return moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
      }
    },
    backendDateFormat(date) {
      if (date) {
        return moment(date, "YYYY-MM-DD").format("DD-MM-YYYY");
      }
    },
    updateOffer() {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "bottom-right",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      this.loading = true;
      const form = new FormData();
      let id = this.$router.currentRoute.params.id;
      if (
        this.categories.offer_in == "percent" &&
        this.categories.offer_value > 100
      ) {
        Toast.fire({
          icon: "Error",
          title: "Offers value cannot be greater than 100",
        });
        return;
      }
      form.append("offer_in", this.categories.offer_in);
      form.append("category_id", this.category_id);
      form.append("offer_value", this.categories.offer_value);
      form.append("location", this.categories.location);
      form.append("pincode", this.categories.pincode);
      form.append("valid_till", this.categories.valid_till);
      form.append("valid_from", this.categories.valid_from);
      form.append("description", this.categories.description);
      form.append("short_description", this.categories.short_description);
      API.post("/offer/update_offer/" + id, form, {
        headers: { Authorization: this.token },
      }).then((res) => {
        console.log(res.data);
        if (res.data.status == 200) {
          Toast.fire({
            icon: "success",
            title: res.data.messages,
          });
          this.$router.push("/offer-list");
        } else {
          let error = JSON.stringify(res.data.messages);
          Toast.fire({
            icon: "error",
            title: error,
          });
        }
      });
      //axios
    },
  },
};
</script>

<style  scoped>
.category > label {
  margin: 0px;
}
</style>